import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Hint: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0744 14.5854L17.27 13.9914V13.9914L18.0744 14.5854ZM5.92557 14.5854L6.73 13.9914H6.73L5.92557 14.5854ZM7.41667 16.9502H8.41667V16.7503L8.33976 16.5657L7.41667 16.9502ZM7.41667 20H8.41667H8.41667H7.41667ZM16.5833 16.9502L15.6602 16.5657L15.5833 16.7503V16.9502H16.5833ZM19.25 9.70833C19.25 11.2577 18.3565 12.5201 17.27 13.9914L18.8789 15.1795C19.8938 13.8052 21.25 12.021 21.25 9.70833H19.25ZM12 2C15.9538 2 19.25 5.39951 19.25 9.70833H21.25C21.25 4.3982 17.1589 0 12 0V2ZM4.75 9.70833C4.75 5.39951 8.04619 2 12 2V0C6.84111 0 2.75 4.3982 2.75 9.70833H4.75ZM6.73 13.9914C5.6435 12.5201 4.75 11.2577 4.75 9.70833H2.75C2.75 12.021 4.10625 13.8052 5.12114 15.1795L6.73 13.9914ZM8.33976 16.5657C7.95362 15.6388 7.30315 14.7675 6.73 13.9914L5.12114 15.1795C5.73224 16.007 6.21892 16.6756 6.49357 17.3348L8.33976 16.5657ZM8.41667 20L8.41667 16.9502H6.41667L6.41667 20H8.41667ZM10.4167 22C9.3121 22 8.41667 21.1046 8.41667 20H6.41667C6.41667 22.2091 8.20753 24 10.4167 24V22ZM13.5833 22H10.4167V24H13.5833V22ZM15.5833 20C15.5833 21.1046 14.6879 22 13.5833 22V24C15.7925 24 17.5833 22.2091 17.5833 20H15.5833ZM15.5833 16.9502V20H17.5833V16.9502H15.5833ZM17.27 13.9914C16.6968 14.7675 16.0464 15.6388 15.6602 16.5657L17.5064 17.3348C17.7811 16.6756 18.2678 16.007 18.8789 15.1795L17.27 13.9914Z"
        fill={color}
      />
      <line x1="8" y1="17" x2="16" y2="17" stroke={color} strokeWidth="2" />
      <line x1="8" y1="20" x2="16" y2="20" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default Hint;
